import { INITIAL_PAGINATION } from '../../../component/table/component/pagination/utils/Pagination';
import {
  HeadCell,
  ACTION,
  ACTION_SWITCH,
} from '../../../component/table/interfaces/TableInterface';
import { InterfacePagination } from '../interfaces/InterfacePagination';

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'id', label: 'Número da Loja' },
  { id: 'Nome', label: 'Nome da loja' },
  { id: 'Cidade', label: 'Cidade' },
  { id: 'Bairro', label: 'Endereço' },
  { id: 'UF', label: 'Estado' },
  { id: ACTION, label: 'Ação' },
];

export const HEAD_CELL_MANAGER: Array<HeadCell> = [
  { id: 'id', label: 'Número da Loja' },
  { id: 'Nome', label: 'Nome da loja' },
  { id: 'managerName', label: 'Gerente de Loja' },
  { id: 'managerPhone', label: 'Ger. Telefone' },
  { id: ACTION, label: 'Ação' },
];

export const INITIAL_VALUES_PAGINATION: InterfacePagination = {
  lastPage: INITIAL_PAGINATION.lastPage,
  page: INITIAL_PAGINATION.page,
  sort: INITIAL_PAGINATION.sort,
  order: INITIAL_PAGINATION.order,
};
